export interface PatientAccountOrders {
}

export interface PatientAccountOrdersState {
	records: Array<PatientAccountOrders>
}

export enum PATIENT_ACCOUNT_ORDERS_ACTION_TYPES {
	PATIENT_ACCOUNT_ORDERS = 'PATIENT_ACCOUNT_ORDERS',
}

export interface PatientAccountOrdersSetAction {
	type: PATIENT_ACCOUNT_ORDERS_ACTION_TYPES.PATIENT_ACCOUNT_ORDERS
	payload: Array<PatientAccountOrders>
}

export type PatientAccountOrdersActions = PatientAccountOrdersSetAction
